import { ExternalLink } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils';

interface ViewAllEvaluationsButtonProps {
  href: string;
  size?: 'xs' | 'sm';
  className?: string;
}

export const ViewAllEvaluationsButton: React.FC<ViewAllEvaluationsButtonProps> = ({
  href,
  size = 'sm',
  className,
}) => (
  <Button asChild variant="outline" size={size} className={cn('gap-1', className)}>
    <Link to={href} target="_blank" rel="noopener noreferrer">
      View all evaluations <ExternalLink className="h-4 w-4" />
    </Link>
  </Button>
);
